export default __webpack_public_path__ + "media/images/react_icons/property/balcony-ac210619d0ac742932cb60c093f44367.svg";